import { LABEL_QUEST, LABEL_QUEST_IMG } from "../constants.js";
import { createImagePicker } from "../imagePicker.js";

export function structureSlider(id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-sliders"></i> Schieberegler (Slider)</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST}</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-frage placeholder="z. B. Wie hoch ist dein Budget?">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST_IMG}</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary"
                    data-bs-toggle="collapse" data-bs-target="#node${id}-options">Optionen</button>
                <div id="node${id}-options" class="answers collapse">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Minimum</label>
                                <div class="col-12">
                                    <input type="number" class="form-control form-control-sm" value="0" df-min>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Maximum</label>
                                <div class="col-12">
                                    <input type="number" class="form-control form-control-sm" value="100" df-max>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Schrittweite (Step)</label>
                                <div class="col-12">
                                    <input type="number" class="form-control form-control-sm" value="1" min="0.01" step="any" df-step>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Startwert (Default)</label>
                                <div class="col-12">
                                    <input type="number" class="form-control form-control-sm" value="50" df-default>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Präfix (optional)</label>
                                <div class="col-12">
                                    <input type="text" class="form-control form-control-sm" placeholder="z. B. ca. " df-prefix>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="col-12">Einheit / Suffix</label>
                                <div class="col-12">
                                    <input type="text" class="form-control form-control-sm" value="€" placeholder="z. B. €, m², Jahre, %" df-unit>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
